import { useMutation } from "@tanstack/react-query";

import createRegulatorPortalInstance from "../../api/RegulatorPortalInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { getRegulatorPortalToken } from "../../utils/tokenUtils";

/**
 * Server-side sign-out for the regulator portal, mirroring the affiliate
 * portal's `usePortalSignOut`. The shared auth endpoint authenticates purely
 * on the access token (`get_user` → `global_sign_out`), so it revokes a
 * regulator session the same way it does a staff or affiliate one.
 *
 * The call is best-effort: callers tear the client session down in
 * `onSettled` regardless of the outcome.
 */
const regulatorSignOut = async (): Promise<void> => {
  const token = getRegulatorPortalToken();
  const instance = createRegulatorPortalInstance();

  await instance.post(API_ROUTES.SIGN_OUT, {
    request_token: token?.AccessToken,
  });
};

export const useRegulatorSignOut = () =>
  useMutation<void, Error>({
    mutationKey: ["regulator-portal", "signOut"],
    mutationFn: regulatorSignOut,
  });
